import { render, staticRenderFns } from "./photo-company.vue?vue&type=template&id=aea54bb2&scoped=true&"
import script from "./photo-company.vue?vue&type=script&lang=js&"
export * from "./photo-company.vue?vue&type=script&lang=js&"
import style0 from "./photo-company.vue?vue&type=style&index=0&id=aea54bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea54bb2",
  null
  
)

export default component.exports